<template>
    <div class="main-widget-container" :class="{'no-options' : noOptionsProduct}">
        <section
            v-if="!controllerError && activeProduct"
            :class="{'no-options-cart': noOptionsProduct}"
            class="add-to-cart-section"
            id="addToCartSection"
        >
            <!-- Normal Products -> Selection Widget -->
            <SelectionWidgetDesktop
                v-if="showSelectionWidget"
                :lock-buttons="floatBtn.loadingBar > 0 || isLoading"
                :empty-selection-warning="globalCartWarningEvent"
                @add-to-cart="addToCart"
                @stock-form-update="stockFormUpdate"
                @float-btn-routing="floatBtnRouting"
                ref="selectionWidget"
            />

            <!-- no options products solo QTY -->
            <div v-if="!showSelectionWidget && (noOptionsProduct || isPack || showQty)"
                 class="cart-options-section"
                 :class="{'solo' : !isPack}"
                 id="'cartOptions-0"
            >
                <div class="button-options single-option">
                    <QuantityPicker
                        v-model="currentQty"
                        :label="kStrings.kGLOB_QUANTITY"
                        :class="{'disabled' : disableQty}"
                        :default-qty="cartItemQty"
                        :qty-limit="qtyLimit"
                        class="order-0"
                    />
                </div>
            </div>

            <!-- PACK Widget -->
            <Packs
                v-if="isPack"
                :lock-button="floatBtn.loadingBar > 0"
                @float-btn-routing="floatBtnRouting"
                ref="packWidget"
            />

            <!-- END PACK Widgets -->
            <!-- STOCK INFO -->
            <transition name="fade">
                <NotificationAlert v-if="notificationAlert && notificationAlert.context == 'stock'"/>
            </transition>
            <transition enter-active-class="enter-active"
                        leave-active-class="leave-active"
                        @before-enter="beforeEnter"
                        @enter="enter"
                        @after-enter="afterEnter"
                        @before-leave="beforeLeave"
                        @leave="leave"
                        @after-leave="afterLeave">
                <StockAlert :show-label="!reasonDetailContent" v-if="!campaignStockLimit && outOfStock" />
            </transition>
            <section v-if="overrideStatus && overrideStatusReasonDetail" class="mx-0 w-100 add-to-cart-section cart-unavailable">
                <span class="warning-text col pr-0"> <i class="prz-error"/> {{ overrideStatusReasonDetail }} </span>
            </section>
            <div v-if="overrideStatus && labelModalInfo && reasonDetailContent" class="mx-0 w-100 override-more-info"> 
                <div class="d-flex align-items-center" @click="moreInfo">
                    <i class="prz-info"></i>
                    <span>{{ labelModalInfo }}</span> 
                </div>
            </div>
            <!-- END STOCK POPUP INFO -->
            <FloatBtn
                v-show="!outOfStock"
                class="fixed-btn"
                :class="{ 'active-in-fp' : showPagePopup }"
                :lock-button="floatBtn.loadingBar > 0"
                :disabled="overrideStatus"
                @float-btn-routing="floatBtnRouting"
            />
        </section>
        <NotificationAlert v-else :notice-prop-data="{type: 'error', message: controllerError ? kStrings.kGLOB_ERROR_MSG : nonActiveProductLabel, icon: 'prz-error'}"  />
        <PDPContextNotification v-if="campaignStockLimit" :context-notification="contextNotification" :selected-product="selectedProduct"/>
    </div>
</template>

<script>
import FloatBtn from '@/components/ProductPage/Desktop-BlackRabbit/AddToCartDesktop/partials/buttonTypes/FloatBtn.vue';

import SelectionWidgetDesktop from '@/components/ProductPage/Desktop-BlackRabbit/AddToCartDesktop/partials/SelectionWidgetDesktop.vue';
import OptionBtn from '@/components/ProductPage/Desktop-BlackRabbit/AddToCartDesktop/partials/buttonTypes/OptionBtn';

import StockAlert from '@/components/ProductPage/Desktop-BlackRabbit/AddToCartDesktop/partials/forms/StockAlert';
import Packs from '@/components/ProductPage/Desktop-BlackRabbit/AddToCartDesktop/partials/selectionTypes/listPickers/Packs';
import Popper from '@/components/Muffin/Popper';

import utilities from '@/Utilities/common';
//import utilsHeader from '@/Utilities/desktop-header';
import {storePdp} from '@/store/product-page';
import pdpEvents from '@/Utilities/events-pdp/events';

import request from '@/Utilities/httpRequest';

import {cloneDeep, isEmpty} from 'lodash-es';
import NotificationAlert
    from "@/components/ProductPage/Desktop-BlackRabbit/AddToCartDesktop/partials/popupTypes/NotificationAlert.vue";
import QuantityPicker
    from "@/components/ProductPage/Desktop-BlackRabbit/AddToCartDesktop/partials/selectionTypes/QuantityPicker.vue";

export default {
    storePdp,
    //storeHeader,
    name: 'addToCartDesktop',
    components: {
        QuantityPicker,
        NotificationAlert,
        Packs,
        OptionBtn,
        StockAlert,
        SelectionWidgetDesktop,
        FloatBtn,
        Popper,
        PDPContextNotification: () => import('@/components/ProductPage/Mobile-BlackRabbit/PDPContextNotification.vue'),
    },
    props: {
        contextNotification:{
            type: Object,
            default: null,
        }
    },
    data() {
        return {
            currentQty: 1,
            showMoreInfo:false,
            overrideReasonDetail: '',
            pknItemAllVariantsOutOfStock: false
        };
    },
    computed: {
        isLoading() {
            return storePdp.getters['pdpDesktop/isLoading'];
        },
        controllerError() {
            return storePdp.getters['pdpDesktop/addToCartDesktop/controllerError'];
        },
        globalCartWarningEvent() {
            return storePdp.getters['pdpDesktop/addToCartDesktop/globalCartWarningEvent'];
        },
        activeProduct() { // shows widgets and
            // NL products are special cases...
            // no AC -> TI with no override set to active
            //if(this.productStatus == 'NL' || this.productStatus == 'NV') {
            //if(this.productStatus == 'NL' || (this.productStatus == 'TI' && !this.overrideStatus)) {
            if(this.productStatus == 'NL' || this.productStatus == 'TI') {
                return true;
            }

            // NV TOO...
            if(this.productStatus == 'NV') {
                return false;
            }

            return this.productStatus == 'AC' || (this.basicInfo && this.basicInfo.isActive);
        },
        nonActiveProductLabel() {
            if(this.activeProduct) {
                return null;
            }

            let label = this.kStrings.kTEMPORARILY_UNAVAILABLE;
            switch (this.productStatus) {
                case 'DE':
                    label = this.kStrings.kPRODUCT_IS_NOT_AVAILABLE;
                case 'NV':
                    label = this.kStrings.kPRODUCT_IS_NOT_AVAILABLE;
                    if(this.basicInfo.isSampleProduct && this.productInfo.nvPointsOnly) {
                        label = this.kStrings.kONLY_AVAILABLE_WITH_PROZIS_POINTS;
                    }
                    break;
                case 'CS':
                    label = this.kStrings.kCOMING_SOON_MESSAGE;
                    break;
                default:
            }

            return label;
        },
        kStrings() {
            return storePdp.getters.kStrings;
        },
        criteoData() {
            return storePdp.getters['pdpDesktop/criteoData'];
        },
        basicInfo() {
            return storePdp.getters['pdpDesktop/basicInfoData'];
        },
        productCartData() {
            return storePdp.getters['pdpDesktop/addToCartData'];
        },
        currency() {
            return storePdp.getters['pdpDesktop/addToCartDesktop/currency'];
        },
        productType() {
            return this.productCartData.productType;
        },
        productStatus() {
            if(!isEmpty(this.selectedProduct) && !this.selectedProduct.overrideStatus) {
                return this.selectedProduct.status;
            }
            return storePdp.getters['pdpDesktop/addToCartDesktop/productStatus'];
        },
        noOptionsProduct() {
            return storePdp.getters['pdpDesktop/addToCartDesktop/noOptionsProduct'];
        },
        isPack() {
            return storePdp.getters['pdpDesktop/addToCartDesktop/isPack'];
        },
        /*packItemsLabel() {
            return storePdp.getters['pdpDesktop/addToCartDesktop/packItemsLabel'];
        },*/
        packData() {
            return storePdp.getters['pdpDesktop/addToCartDesktop/packData'];
        },
        productInfo() {
            return this.productCartData.productInfo;
        },
        cartAuxData() {
            return this.productCartData.cartAuxData;
        },
        // showQuantityWidget() {
        //     return storePdp.getters['pdpDesktop/addToCartDesktop/showQuantityWidget'];
        // },
        qtyLimit() {
            if(this.isPack && !this.outOfStock) {
                return 5;
            }

            return storePdp.getters['pdpDesktop/addToCartDesktop/qtyLimit'];
        },
        isPack() {
            return storePdp.getters['pdpDesktop/addToCartDesktop/isPack'];
        },
        // showQty() {
        //     if(this.isPack || this.selectedProduct && this.selectedProduct.stock == 0) {
        //         return false;
        //     }

        //     return this.showQuantityWidget || this.showSoloQtyBtn;
        // },
        cartItemQty() {
          /*  if(!this.showQty) {
                return 1;
            }*/

            return storePdp.getters['pdpDesktop/addToCartDesktop/cartItemQty'];
        },
        selectionData() {
            if(this.isPack) {
                return storePdp.getters['pdpDesktop/addToCartDesktop/packData'];
            }
            return storePdp.getters['pdpDesktop/addToCartDesktop/selectionData'];
        },
        selectedProduct() {
            return storePdp.getters['pdpDesktop/addToCartDesktop/selectedProduct'];
        },
        selectedPackProducts() {
            return storePdp.getters['pdpDesktop/addToCartDesktop/selectedPackProducts'];
        },
        disableQty() {
            // TODO optimize this condition
            if(this.forcePknUserPick) {
                return true;
            }

            return (!this.selectedProduct && !this.showSoloQtyBtn) || ((this.floatBtn.loadingBar > 0 || this.isLoading || this.outOfStock) || this.qtyLimit == 1) || this.selectedProduct.stock == 0;
        },
        selectedSkuData(){
            let skus = null;
            let sku = null;
            let groupId = this.productInfo.groupId;
            if (this.productType === 'pack') {
                sku = this.packData.basePackInfo ? this.packData.basePackInfo.sku : sku;
                skus = sku ? this.selectedPackProducts.map(product => product.sku) : skus;
            } else if (this.productType === 'packStatic') {
                sku = this.packData.basePackInfo ? this.packData.basePackInfo.sku : sku;
            } else {
                sku = this.selectedProduct.sku;
                groupId = sku ? this.selectedProduct.relativeGroupId : null;
            }

            return !sku ? null : {
                groupId: groupId,
                sku: sku,
                skus: skus,
            }
        },
        quantityBuyStruct(){
            return Array.isArray(storePdp.getters.QuantityBuyStruct) ? storePdp.getters.QuantityBuyStruct : null;
        },
        stockAlertForm() {
            return storePdp.getters['pdpDesktop/addToCartDesktop/stockAlertForm'];
        },
        notificationAlert() { // used for stock alert, TI, etc
            /*if(this.productStatus == 'TI') {
                return null;
            }*/
            return storePdp.getters['pdpDesktop/addToCartDesktop/toastNotification'];
        },
        floatBtnMode() {
            let mode = 'trigger-empty-warning';
            if (this.overrideStatus) {
                mode = 'temp-unavailable';
            } else if (this.outOfStock) {
                mode = 'notify-me';
            } else if (this.canAddToCart) {
                mode = 'add-to-cart';
            } else if ((this.isPack && this.productType !== 'packStatic') && this.forcePknUserPick) {
                mode ='trigger-pkn-page';
            }
            return mode;
        },
        floatBtnLabel() {
            let label = this.kStrings.kGLOB_ADD_TO_CART;
            if (this.floatBtnMode === 'notify-me') {
                label = this.kStrings.kNOTIFY_ME_SINGLE;
            } else if (this.floatBtnMode === 'temp-unavailable') {
                label = this.kStrings.kTEMPORARILY_UNAVAILABLE;
            }
            return label;
        },
        floatBtn() {
            return storePdp.getters['pdpDesktop/addToCartDesktop/floatBtn'];
        },
        overrideStatusReasonDetail() {
            let warning = this.kStrings.kTEMPORARILY_UNAVAILABLE;
            if (this.selectedProduct.overrideStatus) {
                warning = this.selectedProduct.overrideStatus.reasonDetail;
            }

            return warning;
        },
        overrideStatus() {
            return this.productStatus === 'TI' || (this.selectedProduct && this.selectedProduct.overrideStatus && this.selectedProduct.overrideStatus.hasOwnProperty('reasonDetail'));
        },
        labelModalInfo(){
            return this.selectedProduct.overrideStatus && this.selectedProduct.overrideStatus.hasOwnProperty('reasonDetail') ? this.selectedProduct.overrideStatus.moreInfoModal : '';
        },
        reasonDetailContent(){
            return this.selectedProduct.overrideStatus && this.selectedProduct.overrideStatus.hasOwnProperty('content') ? this.selectedProduct.overrideStatus.content : null;
        },
        outOfStock() {
            if (this.overrideStatus) {
                return true;
            } else if (this.isPack) {
                if(this.selectedPackProducts.length && this.selectedPackProducts.find(product => product.stock < 1) || this.pknItemAllVariantsOutOfStock){
                    return true;
                }

                return !this.productCartData.hasStock;
            } else if (!isEmpty(this.selectedProduct)) {
                return this.selectedProduct.stock < 1;
            } else{
                if(this.selectionData.hasOwnProperty('productsList')){
                    // check for out of stock in grouped products
                    return !this.hasProductWithStock(this.selectionData.productsList, this.productInfo.groupId);
                }

                let hasStock = this.basicInfo.hasStock;
                if(!hasStock){
                    return true;
                }
            }

            return false;
        },
        numberOfPackItems() {
            if(!this.isPack) {
                return 0;
            }
            return Object.keys(this.packData.items).length;
        },
        readyPackItems() {
            return storePdp.getters['pdpDesktop/addToCartDesktop/readyPackItems'];
        },
        numberOfReadyPackItems() {
            return storePdp.getters['pdpDesktop/addToCartDesktop/numberOfReadyPackItems'];
        },
        forcePknUserPick() {
            if(!this.isPack) {
                return false;
            }
            return this.numberOfReadyPackItems != this.numberOfPackItems;
        },
        canAddToCart() {
            if(this.isPack && !this.forcePknUserPick) {
                return true;
            }

            // and stock??
            return !isEmpty(this.selectedProduct);
        },
        showSoloQtyBtn() { // for no options only, check SelectionWidget if it's not the case
            return storePdp.getters['pdpDesktop/addToCartDesktop/showSoloQtyBtn'];
        },
        singleOption() {
            return this.selectionData.singleOption || this.showSoloQtyBtn;
        },
        showSelectionWidget() {
            if(this.noOptionsProduct) {
                return false;
            }

            return (!this.isPack) || this.showSoloQtyBtn;
        },
        showOptionsPopup() { // '' (hides), primary, secondary or qty (shows)
            return storePdp.getters['pdpDesktop/addToCartDesktop/showOptionsPopup'];
        },
        showPagePopup() { // '' (hides), pack, stock form, etc.. (shows)
            return storePdp.getters['pdpDesktop/addToCartDesktop/showPagePopup'];
        },
        headerData() {
            return storePdp.getters['pdpDesktop/headerData'];
        },
        showQuantityWidget() {
            return storePdp.getters['pdpDesktop/addToCartDesktop/showQuantityWidget'];
        },
        showQty() {
            //if(this.isPack || this.selectedProduct && this.selectedProduct.stock == 0) {
            if(this.isPack) {
                return false;
            }

            return this.showQuantityWidget || this.showSoloQtyBtn;
        },
        campaignStockLimit() {
            if(this.contextNotification && this.contextNotification.showContextNotification && this.selectedProduct && this.selectedProduct.campaignStockLimit){
                if(this.selectedProduct.stock){
                    storePdp.dispatch('showStockLabel', true);
                    return true;
                }else if (!this.selectedProduct.stock && this.selectedProduct.displayType == 'LAYOUT_PROMOTER_NOT_ELIGIBLE' ){
                    storePdp.dispatch('showStockLabel', false);
                    return true;
                }
            }
            storePdp.dispatch('showStockLabel', true);
            return false;
        }
    },
    watch: {
        outOfStock: {
            immediate: true,
            handler(value, oldValue) {
                // this watch is spammy and buggy, redo this
                let stockLabel = value === true ? this.kStrings.kPROD_STOCK_OUT : this.kStrings.kIN_STOCK;
                if(this.productStatus == 'TI') {
                    stockLabel = this.kStrings.kUNAVAILABLE;
                }
                storePdp.dispatch('updateStockLabel', stockLabel);
                storePdp.dispatch('updateHasStock', !value);
                //storePdp.dispatch('pdpDesktop/addToCartDesktop/updateFloatBtn', {pointsBtn: {hide: value}});
            },
        },
        canAddToCart: {
            immediate: true,
            handler(value, oldValue) {
                storePdp.dispatch('pdpDesktop/addToCartDesktop/updateCanAddToCart', value);
            },
        },
        floatBtnLabel: {
            immediate: true,
            handler(value, oldValue) {
                storePdp.dispatch('pdpDesktop/addToCartDesktop/updateFloatBtn', {label: value});
            },
        },
        floatBtnMode: {
            immediate: true,
            handler(value, oldValue) {
                storePdp.dispatch('pdpDesktop/addToCartDesktop/updateFloatBtn', {mode: value});
            },
        },
        quantityBuyStruct: {
            deep: true,
            handler(val) {
                if(!isEmpty(val) && !this.showSelectionWidget) {
                    let findSku = this.selectedProduct && this.selectedProduct.stock > 1 ? val.find(e => e.sku == this.selectedProduct.varSku) : '';
                    if (findSku) {
                        storePdp.dispatch('pdpDesktop/addToCartDesktop/updateCartItemQty', findSku.quantityBuy);
                        this.currentQty = findSku.quantityBuy;
                    } else {
                        storePdp.dispatch('pdpDesktop/addToCartDesktop/updateCartItemQty', 1);
                        this.currentQty = 1;
                    }
                }
            }
        },
        selectedSkuData(val, oldVal){
            if(this.canAddToCart && oldVal && oldVal.groupId && val.groupId && val.sku && val.sku != oldVal.sku){
                pdpEvents.addSkuSelected(val.groupId, val.sku, val.skus);
            }
        },
    },
    methods: {
        goto(url = '') {
            utilities.goToUrl(url);
        },
        mountedMethods(data) {
            storePdp.dispatch('pdpDesktop/addToCartDesktop/initCartData', data);
        },
        // all in one now :)
        updateShowPagePopup(page = '') {
            // '' closes
            storePdp.dispatch('pdpDesktop/addToCartDesktop/updateShowPagePopup', page);
        },
        // ------------
        stockFormUpdate(notificationSku = '', label= '', description = '', date = '') {
            //console.log('notificationSku: ', notificationSku);
            storePdp.dispatch('pdpDesktop/addToCartDesktop/updateStockAlertForm', {
                variant: {
                    label: label,
                    description: description,
                    availableDate: date
                },
                notificationSku: !this.isPack ? notificationSku : this.productInfo.sku,
                isGroup: false
            });
        },
        async addToCart(addPoints = false) {
            if (!this.canAddToCart) {
                return;
            }
            // Selected Option in Param is meant for the reload
            let addSuccessful = false;
            let price = null;
            let coupon = null;

            if (this.productType === 'pack') {
                price = this.selectedPackProducts.map(product => product.priceVal);
            } else if (this.productType === 'packStatic') {
                price = this.packData.basePackInfo.priceVal ? this.packData.basePackInfo.priceVal : null;
            } else {
                price = this.selectedProduct.priceVal ? this.selectedProduct.priceVal : null;
                coupon = storePdp.getters['priceCoupons/getAutoApply'](this.selectedProduct.relativeGroupId);
            }

            const skuData = this.selectedSkuData;

            //this.floatBtnLoadingBarControl();
            this.updateFloatBtnStatus(99, '', addPoints);
            try {
                const {data} = await request.post(this.cartAuxData.cartAddFormInfo.addActionUrl,
                    {
                        sku: skuData.sku,
                        skus: skuData.skus,
                        qty: this.cartItemQty,
                        program: null,
                        price: price,
                        cpn: coupon ? coupon : null,
                        type: addPoints ? 1 : null,
                        oti: utilities.getMubOtiData(true),
                    },
                    false,
                );
                let hasError = !data || data.hasError;
                //console.log('cart response: ', data);

                if (!hasError) {
                    // update number of items in cart icon (only updates line)
                    //let numCartItems = data.numCartItems;
                    if (data.numCartItems) {
                        //let message = data.msg ? data.msg : this.kStrings.kCART_UPDATE_SUCCESS;
                        //VueEs6.addToCartDesktop.cartItemNumUpdate(numCartItems);
                        VueEs6.header.miniCart.updateAndOpen();
                        storePdp.dispatch('pdpDesktop/addToCartDesktop/updateHeaderCartQty', data.numCartItems);
                    }
                    this.updateFloatBtnStatus(100, '', addPoints);
                    //storePdp.dispatch('pdpDesktop/addToCartDesktop/cartItemNumUpdate', numCartItems);
                    setTimeout(() => {
                        this.updateFloatBtnStatus(0, '', addPoints);
                        if(addPoints && data.hasOwnProperty('pointsInfo')) {
                            storePdp.dispatch('pdpDesktop/addToCartDesktop/updateImmersivePoints', data.pointsInfo);
                        }
                    }, 2250);
                    addSuccessful = true;
                    //this.$emit('handle-match-description');
                } else {
                    let message = data.msg ? data.msg : this.kStrings.kPLZ_TRY_AGAIN;
                    this.updateFloatBtnStatus(100, message, addPoints);
                    //storeHeader.dispatch('updateCartQtyWithAnim', {qty: 0, msg: message});
                    setTimeout(() => {
                        this.updateFloatBtnStatus(0, '', addPoints);
                    }, 1500);
                }
            } catch (error) {
                console.error(error);
                this.updateFloatBtnStatus(100, this.kStrings.kPLZ_TRY_AGAIN, addPoints);
                //storeHeader.dispatch('updateCartQtyWithAnim', {qty: 0, msg: this.kStrings.kSOMETHING_WRONG});
                setTimeout(() => {
                    this.updateFloatBtnStatus(0, '', addPoints);
                }, 1500);
            } finally {
                if (addSuccessful === true) {
                    storePdp.dispatch('pdpDesktop/addToCartDesktop/runTrackers');
                }
            }
        },
        hasProductWithStock(products, groupId){
            if(Array.isArray(products)){
                const p = products.find(element => element.stock > 0 && element.relativeGroupId == groupId)
                return (typeof p !== 'undefined');
            }
            return false;
        },
        // FLOAT BTN FUNCTIONS
        // for add to cart feedback / progress & float detach
        updateFloatBtnStatus(loadingBar = 0, warningLabel = '', updatePointsBtn = false) {
            // loadingBar = 101 -> forcefill
            if(!updatePointsBtn) {
                storePdp.dispatch('pdpDesktop/addToCartDesktop/updateFloatBtn', {
                    loadingBar: loadingBar,
                    warningLabel: warningLabel,
                });
            } else {
                if(this.floatBtn.pointsBtn) {
                    let pointsBtn = cloneDeep(this.floatBtn.pointsBtn);
                    pointsBtn.loadingBar = loadingBar;
                    pointsBtn.warningLabel = warningLabel;
                    storePdp.dispatch('pdpDesktop/addToCartDesktop/updateFloatBtn', {pointsBtn: pointsBtn});
                }
            }
           /* storePdp.dispatch('pdpDesktop/addToCartDesktop/updateFloatBtn', {
                loadingBar: loadingBar,
                warningLabel: warningLabel,
            });*/
        },

        floatBtnRouting(addPoints = false) { // weird name I know
            switch (this.floatBtn.mode) {
                case 'add-to-cart':
                    //this.updateShowPagePopup('');
                    storePdp.dispatch('pdpDesktop/addToCartDesktop/updateGlobalCartWarningEvent', false);
                    this.addToCart(addPoints);
                    break;
                case 'notify-me':
                    //this.updateShowPagePopup('stock');
                    storePdp.commit('pdpDesktop/setScrollMinimalMode', false);
                    break;
                case 'trigger-empty-warning':
                    storePdp.dispatch('pdpDesktop/addToCartDesktop/updateGlobalCartWarningEvent', true);
                    storePdp.commit('pdpDesktop/setScrollMinimalMode', false);
                    break;
                case 'trigger-pkn-page':
                    this.$refs.packWidget.handleWarnings();
                    storePdp.commit('pdpDesktop/setScrollMinimalMode', false);
                    break;
                default:
            }
        },
        // for accordion transitions with dynamic content
        /**
         * @param {HTMLElement} element
         */
        beforeEnter(element) {
            requestAnimationFrame(() => {
                if (!element.style.height) {
                    element.style.height = '0px';
                }

                element.style.display = null;
            });
        },
        /**
         * @param {HTMLElement} element
         */
        enter(element) {
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    element.style.height = `${element.scrollHeight}px`;
                });
            });
        },
        /**
         * @param {HTMLElement} element
         */
        afterEnter(element) {
            element.style.height = null;
        },
        /**
         * @param {HTMLElement} element
         */
        beforeLeave(element) {
            requestAnimationFrame(() => {
                if (!element.style.height) {
                    element.style.height = `${element.offsetHeight}px`;
                }
            });
        },
        /**
         * @param {HTMLElement} element
         */
        leave(element) {
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    element.style.height = '0px';
                });
            });
        },
        /**
         * @param {HTMLElement} element
         */
        afterLeave(element) {
            element.style.height = null;
        },
        moreInfo(){
            storePdp.dispatch('showMoreInfoModal', true);
            utilities.disableBodyScroll();
        },
    },
    created() {},
    beforeDestroy() {},
    mounted() {
        if (this.productCartData) {
            this.mountedMethods(this.productCartData);
        }
    },
};
</script>
<style lang="scss">
@import "styles/addToCartDesktop";
</style>